import { render } from "./a-side-menu.vue?vue&type=template&id=1b83e70d&scoped=true"
import script from "./a-side-menu.vue?vue&type=script&lang=js"
export * from "./a-side-menu.vue?vue&type=script&lang=js"

import "./a-side-menu.vue?vue&type=style&index=0&id=1b83e70d&lang=sass&scoped=true"

import exportComponent from "/opt/bitnami/apps/ocmsta/subdomains/praxisti/htdocs/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b83e70d"]])

export default __exports__